<template>
  <div class="vx-row">
    <div class="vx-col w-full">
      <vs-row class="pb-2">

        <vx-card>




          <vs-row vs-w="12">
            <vs-col vs-type="flex" vs-lg="2" vs-sm="12" vs-xs="12">
              <vs-button @click="goBack" color="danger" type="border" icon="keyboard_backspace">Back</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="8" vs-sm="12" vs-xs="12">
              <h3>{{ campaignDetails['campaign_name'] }}</h3>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="12" vs-xs="12">
            </vs-col>
          </vs-row>



        </vx-card>

      </vs-row>

      <vs-row vs-w="12">


        <vx-card class="mt-3">
          <div class="vx-row p-1">
            <div class="vx-col sm:w-1/3 w-full">

              <div class="vx-row p-1">
                <div class="vx-col w-full">
                  <span>
                    <h5><u class="p-1">Performance</u></h5>
                  </span>
                </div>
              </div>

              <div class="vx-row p-1">
                <div class="vx-col w-full">
                  <span>
                    Opportunity Target: <span class="ml-5">{{ campaignDetails['target_no_of_opportunities'] }} </span>
                  </span>
                </div>
              </div>
              <div class="vx-row p-1">
                <div class="vx-col w-full">
                  <span>
                    Number of Opportunities: <span class="ml-5">{{ campaignDetails['opportunity'] }} </span>
                  </span>
                </div>
              </div>
              <div class="vx-row p-1">
                <div class="vx-col w-full">
                  <span>
                    Delta: <span class="ml-5">{{ campaignDetails['delta'] }} </span>
                  </span>
                </div>
              </div>
              <div class="vx-row p-1">
                <div class="vx-col w-full">
                  <span>
                    On Target % for days billed: <span class="ml-5">{{
                      campaignDetails['on_target_percentage_for_days_billed'] }} </span>
                  </span>
                </div>
              </div>
              <!-- <div class="vx-row p-1">
                <div class="vx-col w-full">
                  <span>
                    Expected Meetings: <span class="ml-5">{{ campaignDetails['expected_meetings'] }} </span>
                  </span>
                </div>
              </div> -->
              <div class="vx-row p-1">
                <div class="vx-col w-full">
                  <span>
                    Longer Term Opportunities: <span class="ml-5">{{ campaignDetails['longer_term_opportunities'] }}
                    </span>
                  </span>
                </div>
              </div>
              <div class="vx-row p-1">
                <div class="vx-col w-full">
                  <span>
                    Number of Value Added Conversations: <span class="ml-5">{{
                      campaignDetails['value_adding_conversations']
                      }} </span>
                  </span>
                </div>
              </div>
              <div class="vx-row p-1">
                <div class="vx-col w-full">
                  <span>
                    Meetings Completed: <span class="ml-5">{{ campaignDetails['meetings_completed'] }} </span>
                  </span>
                </div>
              </div>
              <div class="vx-row p-1">
                <div class="vx-col w-full">
                  <span>
                    Target Pipeline: <span class="ml-5">{{ campaignDetails['target_pipeline'] }} </span>
                  </span>
                </div>
              </div>
              <div class="vx-row p-1">
                <div class="vx-col w-full">
                  <span>
                    Pipeline Generated: <span class="ml-5">{{ campaignDetails['pipeline_generated'] }} </span>
                  </span>
                </div>
              </div>
              <div class="vx-row p-1">
                <div class="vx-col w-full">
                  <span>
                    Weighted Value: <span class="ml-5">{{ campaignDetails['weighted_pipeline'] }} </span>
                  </span>
                </div>
              </div>
              <div class="vx-row p-1">
                <div class="vx-col w-full">
                  <span>
                    Won Revenue: <span class="ml-5">{{ campaignDetails['won_revenue'] }} </span>
                  </span>
                </div>
              </div>
            </div>


            <div class="vx-col sm:w-1/3 w-full">
              <div class="vx-row p-1">
                <div class="vx-col w-full">
                  <span>
                    <h5><u class="p-1">Budget/Days</u></h5>
                  </span>
                </div>
              </div>

              <div class="vx-row p-1">
                <div class="vx-col w-full">
                  <span>
                    Budget: <span class="ml-5">{{ campaignDetails['budget'] }} </span>
                  </span>
                </div>
              </div>

              <div class="vx-row p-1">
                <div class="vx-col w-full">
                  <span>
                    Setup: <span class="ml-5">{{ campaignDetails['setup'] }} </span>
                  </span>
                </div>
              </div>

              <div class="vx-row p-1">
                <div class="vx-col w-full">
                  <span>
                    Total Calling Day Budget: <span class="ml-5">{{ campaignDetails['total_calling_day_budget'] }}
                    </span>
                  </span>
                </div>
              </div>

              <div class="vx-row p-1">
                <div class="vx-col w-full">
                  <span>
                    Calling Day Budget Used: <span class="ml-5">{{ campaignDetails['budget_used'] }} </span>
                  </span>
                </div>
              </div>

              <div class="vx-row p-1">
                <div class="vx-col w-full">
                  <span>
                    Calling Day Budget Remaining: <span class="ml-5">{{ campaignDetails['budget_remaining'] }} </span>
                  </span>
                </div>
              </div>

              <div class="vx-row p-1">
                <div class="vx-col w-full">
                  <span>
                    Total Days: <span class="ml-5">{{ campaignDetails['total_days'] }} </span>
                  </span>
                </div>
              </div>

              <div class="vx-row p-1">
                <div class="vx-col w-full">
                  <span>
                    Days Used: <span class="ml-5">{{ campaignDetails['no_of_day_used'] }} </span>
                  </span>
                </div>
              </div>

              <div class="vx-row p-1">
                <div class="vx-col w-full">
                  <span>
                    Days Remaining: <span class="ml-5">{{ campaignDetails['days_remaining'] }} </span>
                  </span>
                </div>
              </div>

            

            </div>

            <div class="vx-col sm:w-1/3 w-full">
              <div class="vx-row p-1">
                <div class="vx-col w-full">
                  <span>
                    <h5><u class="p-1">PO Information</u></h5>
                  </span>
                </div>
              </div>


              <vs-row vs-w="12" class="mt-1">
                <vs-table class="mb-10" v-if="campaignDetails['po_information']"
                  :data="campaignDetails['po_information']">



                  <template slot="thead">
                    <vs-th>PO Number</vs-th>
                    <vs-th>PO Value</vs-th>
                  </template>

                  <template slot-scope="{ data }">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                      <template v-if="data[indextr].client_id == user_associated_client_id">
                        <vs-td :data="data[indextr].po_number">
                          {{ data[indextr].po_number }}
                        </vs-td>
                        <vs-td :data="data[indextr].campaign_po_value_allocated">
                          {{ data[indextr].campaign_po_value_allocated }}
                        </vs-td>

                      </template>




                    </vs-tr>
                  </template>
                </vs-table>

                <vs-table class="mb-10" v-if="campaignDetails['po_information']"
                  :data="campaignDetails['po_information']">





                  <template slot-scope="{ data }">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                      <template v-if="data[indextr].client_id != user_associated_client_id">

                        <vs-td>
                          Third Party PO
                        </vs-td>


                      </template>



                    </vs-tr>
                  </template>




                </vs-table>
              </vs-row>





              <!-- 
              <div class="vx-row p-1">
                <div class="vx-col w-full">
                  <span>
                    PO Number: <span class="ml-5">{{ campaignDetails['po_number'] }} </span>
                  </span>
                </div>
              </div>

              <div class="vx-row p-1">
                <div class="vx-col w-full">
                  <span>
                    PO Value allocated to campaign: <span class="ml-5">{{
                        campaignDetails['po_value_allocated_to_campaign']
                    }} </span>
                  </span>
                </div>
              </div> -->



            </div>
          </div>








          <vs-row vs-w="12" class="mt-1">



            <vs-col vs-lg="4" vs-sm="4" vs-xs="12">



              <div class="text-center">

                <h5 class="p-1"><u class="p-1">Account Status</u></h5>



                <span>Total Target Accounts: {{ campaignDetails['total_accounts'] }}</span>

              </div>






              <vs-table class="m-10" v-if="campaignDetails" :data="campaignDetails['account_status']">

                <template slot="thead">
                  <vs-th>Status</vs-th>
                  <vs-th>Count</vs-th>
                  <vs-th>%</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].description">
                      {{ data[indextr].description }}
                    </vs-td>
                    <vs-td :data="data[indextr].count_rows">
                      {{ data[indextr].count_rows }}
                    </vs-td>
                    <vs-td :data="data[indextr].status_percentage">
                      {{ data[indextr].status_percentage }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </vs-col>

           













          </vs-row>



        </vx-card>
      </vs-row>






    </div>
  </div>
</template>

<script>
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignsManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import moduleClientUsersManagement from "@/store/client-user-management/moduleClientUserManagement.js";
import vSelect from "vue-select";
import _ from "lodash";
import moment from "moment";
export default {
  data: () => ({
    user_role: null,
    selected_client_user_id: null,
    authorized: true,
    campaignDetails: [],
    selected_campaign: null,
    user_id: null,
    componentKey: 0,
    abilities: null,
    user_associated_client_id: null,
  }),
  components: {
    "v-select": vSelect,
  },
  watch: {

  },
  methods: {
    fetchClientDetails() {

      if (this.user_role == 'Client' || this.user_role == 'Client Administrator') {
        this.selected_client_user_id = this.user_id
      }

      let self = this
      this.$store
        .dispatch("clientUsersManagement/fetchClientUser", this.selected_client_user_id)
        .then(res => {
          console.log("sdfsdfsdf", res);
          if (res) {
            this.user_associated_client_id = res.data.client_id
            self.fetchCampaignDetails()

          }
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.userDescription = true;
            return;
          }
          console.error(err);
        });
    },
    fetchCampaignDetails() {
      let data = {}
      data.campaign_id = this.$route.params.campaignId;
      data.client_id = this.user_associated_client_id

      this.$vs.loading();


      this.$store
        .dispatch("campaignsManagement/fetchCampaignStatistics", data)
        .then(res => {
          this.campaignDetails = res.data;
          this.$vs.loading.close();
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
          this.$vs.loading.close();
        })

        
    },
 
    checkClientUserCampaignPermission() {
      let data = {}
      data.campaign_id = this.$route.params.campaignId;


      if (this.user_role == 'Client' || this.user_role == 'Client Administrator') {

        data.user_id = this.user_id;
      } else {
        data.user_id = this.selected_client_user_id

      }





      // data.user_id = this.user_id;
      this.$store
        .dispatch("campaignsManagement/checkClientUserCampaignPermission", data)
        .then(res => {
          let result = JSON.parse(res.data)

          if (result.length == 0) {
            this.authorized = false
            this.$router.replace("/unauthorized")
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    goBack: function () {
      this.$router.go(-1);
    },
  },
  beforeMount() {
  },
  mounted() {
    var self = this;

    if (this.authorized) {

      self.fetchClientDetails()




    }


  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });


    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];
    // if (this.user_role != 'Client Administrator' && this.user_role != 'Client'){
    //   this.authorized = false
    //   this.$router.replace("/unauthorized")
    // }

    if (this.user_role == 'Sales Developer') {
      this.authorized = false
      this.$router.replace("/unauthorized")
    }

    if (!moduleClientUsersManagement.isRegistered) {
      this.$store.registerModule(
        "clientUsersManagement",
        moduleClientUsersManagement
      );
      moduleClientUsersManagement.isRegistered = true;
    }


    if (!moduleCampaignsManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignsManagement
      );
      moduleCampaignsManagement.isRegistered = true;
    }

    this.campaignId = self.$route.params.campaignId;
    this.selected_client_user_id = self.$route.params.clientUserId;

    this.checkClientUserCampaignPermission()
  }
};
</script>
<style scoped></style>
